import MainNavbar from "./MainNavbar";
import React, { useState, useContext, useEffect } from "react";
import Hero from "./Hero.js";
import { PatentContext } from "../context/PatentContextProvider.js";
import { Link } from "react-router-dom";
import clientImage from "../assets/clientImages/clinet.png"
import { FaArrowUp } from "react-icons/fa6";
import { Footer } from "./Footer.js";

export default function PressReleases() {
  const { pressReleases } = useContext(PatentContext);
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 130) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShowScrollButton(false);
  };

  return (
    <>
      <MainNavbar />
       <Hero bgImage={""} imageText={{ title: "Press Release" }} />
      <div className="flex bg-white justify-center items-center">
        <div className="w-11/12 lg:w-4/5  mt-10 mb-3 py-5 px-6">
          {/* <h2 className="text-3xl text-[#01a4e4] pb-5 font-bold text-center">
            Press Release
          </h2> */}
          {/* {pressReleases.map((article, index) => (
            <div
              key={index}
              className="flex flex-col md:flex-row gap-5 pb-5 border-t-2 border-[#01a4e4] pt-5"
            >
              <div className="text-sm md:text-base font-medium w-full md:w-[15%] min-w-[120px] text-center md:text-left">
                {article.dateOfRelease}
              </div>
              <div className="flex-1">
                <h3 className="text-gray-800 font-bold text-lg mb-2">
                  {article.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base mb-3">
                  {article.info}
                </p>
                <a
                  href={article.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-blue-500 hover:text-blue-700"
                >
                  Read More
                </a>
              </div>
            </div>
          ))} */}

          <p className="text-center font-bold text-xl">Marquis Who’s Who Honors Kenneth P. O'Hanlon for Outstanding Achievements and Creativity in Technology and Business</p>
          <p className="pt-5 pb-5 text-lg" style={{ fontStyle: 'italic' }}>Kenneth P. O’Hanlon is a visionary leader, dynamic thinker, and rainmaker in mobile marketing technology with a track record of motivating teams and a foundation of service in the Royal Marine Commandos.</p>
          <p>PARKER, CO, October 29, 2025, Kenneth O'Hanlon has been selected for inclusion in Marquis Who's Who. As in all Marquis Who’s Who biographical volumes, individual profiles are selected based on and current reference value. Factors such as position, noteworthy accomplishments, visibility, and prominence in a field are all considered during the selection process. </p>

          <div className="flex my-4">
            <div className="img-div w-[80%]">
              <img className="h-72 fit-content " src={clientImage} />
            </div>
            <div className="text-md/7 text-justify">
              Mr. O'Hanlon, born in London, has established a distinguished career marked by innovation, resilience, and service. As founder and chief executive officer of Technologist, he has led the company, focusing on developing advanced solutions in the technology sector since 2003. Under his leadership, Mr. O'Hanlon holds several patents, such as the share button, geolocation-based opt-in/opt-out for Android and iPhone, a text-in info system, photo and video transmission for analog phones, handset recognition, and journey tracking systems. Creating the first Mobile & Internet marketing system These achievements underscore his inventive approach and commitment to technological advancement.
              <div className="mt-6">
                Before his current role, Mr. O'Hanlon owned and operated HK Home Inspections in the United States. Drawing on his military background and attention to detail, he established a reputable business offering clients comprehensive property assessments. His transition into entrepreneurship was influenced by his earlier experiences in personal security for high-profile individuals, which required discretion and adaptability.
              </div>
            </div>

          </div>
          <div className="text-justify my-5">
            Mr. O'Hanlon’s professional journey began with a career in the Royal Marine Commandos of the British Armed Forces. His tenure was defined by perseverance and exceptional accomplishment. Most notably, he completed a grueling 30-mile march over the challenging and rugged terrain across Dartmoor in eight hours—a feat achieved by only six out of an original group of 52 candidates, which earned him the prestigious Green Beret (known by Bootneck’s as the Green lid). This milestone stands as a testament to his determination and physical endurance.
          </div>
          <div className="mb-5 text-md/7">
            Throughout his career, Mr. O'Hanlon has been an active member of several esteemed organizations, including the Freemasons 32nd Degree, the Knights of the Temple, and the Shriners. These affiliations reflect his dedication to personal growth and community service.
          </div>
          <div className="text-md/7 mb-5">
            Beyond his professional pursuits, Mr. O'Hanlon has made significant contributions to civic life. He was pivotal in establishing high school youth rugby in Colorado and supporting women’s and men's rugby teams. Additionally, he coached LGBTQ rugby teams, fostering inclusivity within the sport. He was the Royal Marine, Royal Navy Judo Champion, A Krav Maga & Gutter Fighting instructor, and a Wrestling Gold medalist in Freestyle, Greco, and Sambo wrestling a Russian martial art. His efforts have had a lasting impact on local athletic communities and have been recognized with honors, including the Denver Business Journal award for Technology on June 6th, 2008.
          </div>
          <div className="mb-5">
            Despite facing challenges related to dyslexia during his formative years, when understanding the condition was limited, Mr. O'Hanlon demonstrated remarkable resilience. With support from a patent attorney who recognized his potential, he overcame these obstacles to secure his first and four more patents, exemplifying creativity and perseverance.
          </div>
          <div className="mb-5">
            Family remains central to Mr. O'Hanlon’s life; he is the father of seven children and takes great pride in his growing legacy, particularly cherishing the arrival of his great-grandson. He continues supporting his grandson in the United Kingdom as he embarks on a new business venture, offering financial assistance and guidance in website development.
          </div>
          <div className="mb-5">
            Looking ahead, Mr. O'Hanlon is dedicated to ensuring his developing platform achieves its full potential with AI systems & GAI systems. He remains committed to helping others whenever possible, balancing progress and perfection in all endeavors.
          </div>
          <div className="mb-5">Video of <Link to="https://www.dropbox.com/scl/fi/jozs889zsxxme3ng9hrr4/VID-20250929-WA0000.mp4?rlkey=uvta4425ao517745hidhetzv5&e=1&st=h7cnn2i2&dl=0" style={{ color: "blue", textDecoration: "underline" }}>ask-jeeves.ai</Link></div>
          <div className="mb-5">
            <Link to="https://www.dropbox.com/scl/fi/w11cppr1ek64edmjdtsf2/Kenneth-Voice-Clone.mp3?rlkey=4rxvy5ijgbwl6cwh9zrj1ixpz&e=1&st=ax0j04r7&dl=0"
            style={{textDecoration: "underline", color: "blue"}}>Voice Clone</Link>
          </div>
          <div>
            <p className="font-bold text-lg mb-2">About Marquis Who’s Who®:</p>
            <p>Since 1899, when A. N. Marquis printed the First Edition of Who’s Who in America®, Marquis Who’s Who® has chronicled the lives of the most accomplished individuals and innovators from every significant field of endeavor, including politics, business, medicine, law, education, art, religion and entertainment. Who’s Who in America® remains an essential biographical source for thousands of researchers, journalists, librarians and executive search firms around the world. The suite of Marquis® publications can be viewed at the official Marquis Who’s Who® website, <Link style={{ textDecoration: "underline" }} to="http://www.marquiswhoswho.com/">www.marquiswhoswho.com.</Link> </p>
            <p className="mt-5" style={{fontStyle: "italic"}}>
            Marquis Who’s Who (“the company”) reserves the right to edit, revise, condense or reject any approved material for style, professionalism and matters of falsity, bigotry, politics, slander, taste, ethics, business practices, or other matters, which the company, at its discretion, may deem offensive, divisive or objectionable.
            </p>
          </div>
        </div>

      </div>
      <div className="w-full">
        {showScrollButton && (
          <button
            className="fixed bottom-5 right-7 md:bottom-10 md:right-10 lg:bottom-16 lg:right-16 bg-black bg-opacity-60 text-white rounded-full p-3 text-xl md:text-2xl shadow-lg hover:bg-opacity-80"
            onClick={scrollToTop}
          >
            <FaArrowUp />
          </button>
        )}
      </div>
      <Footer />
    </>
  );
}
